'use strict';
const angular = require('angular');

export default angular.module('appApp.sidebarfooter', [])
  .directive('sidebarfooter', function() {
    return {
      template: require('./sidebarfooter.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/sidebarfooter/sidebarfooter.directive.js